import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-442794c2")

_pushScopeId("data-v-442794c2")
const _hoisted_1 = { class: "flex flex-col mt-4 gap-x-4" }
const _hoisted_2 = {
  class: "bg-white w-full rounded-xl p-6",
  style: {"border":"1px solid #EBEBEB"}
}
const _hoisted_3 = {
  class: "text-14px font-semibold xxl:text-16px",
  style: {"color":"#333"}
}
const _hoisted_4 = { class: "flex flex-row justify-between border-b py-3 px-4" }
const _hoisted_5 = { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4",
  alt: "up"
}, null, -1)
const _hoisted_7 = { class: "flex flex-col gap-y-4 p-4" }
const _hoisted_8 = { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_10 = { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }
const _hoisted_11 = { class: "gap-x-2 flex flex-row items-center w-full repair-bulk-booking-client-search" }
const _hoisted_12 = { class: "flex pt-1 flex-row items-center" }
const _hoisted_13 = { class: "items-center w-full flex flex-wrap flex-row" }
const _hoisted_14 = { class: "bg-gray-lp-1100 flex flex-row items-center rounded px-2 py-1 mr-1 mb-2 whitespace-no-wrap" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_17 = { class: "flex flex-row justify-between border-b py-3 px-4" }
const _hoisted_18 = { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4",
  alt: "up"
}, null, -1)
const _hoisted_20 = { class: "flex flex-col gap-y-4 p-4" }
const _hoisted_21 = { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }
const _hoisted_22 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_23 = { class: "text-14px font-normal font-montserrat text-gray-lp-300 px-2" }
const _hoisted_24 = {
  class: "mt-5 flex relative w-full overflow-auto",
  style: {"max-height":"34rem"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_AdvancedFilter = _resolveComponent("AdvancedFilter")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Search = _resolveComponent("Search")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('bulkBooking.clientName')), 1),
        _createVNode("div", {
          class: 
            `flex flex-row items-center ${
              _ctx.isErrorClient || _ctx.errorMandatory ? 'mt-0' : 'mt-2'
            }`
          
        }, [
          _createVNode(_component_AdvancedFilter, {
            "custom-max-height": "60vh",
            "model-value": _ctx.filterClient,
            isDisabled: "",
            onOpened: _ctx.onOpenedAdvancedFilter,
            onReset: ($event: any) => (
              {
              }
            ),
            addSumFilter: _ctx.sumFilter,
            showIconFilter: true,
            showCountFilter: false,
            showChevron: false,
            isSeparateContent: "",
            customTitleFilter: "text-14px font-semibold text-gray-lp-300",
            customPaddingVerticalHeader: "py-2.5 bg-gray-lp-1500",
            class: "cursor-not-allowed"
          }, {
            "custom-filter": _withId(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('bulkBooking.filterClientName')), 1),
                _hoisted_6
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('bulkBooking.cityOriginClient')), 1),
                _createVNode(_component_SelectSearchV2, {
                  onFilter: _ctx.fetchCityDestination,
                  onFocus: _ctx.fetchCityDestination,
                  isLoading: _ctx.loadingCityDestination,
                  options: _ctx.cityDestinationData,
                  keyName: "name",
                  keyValue: "name",
                  placeholder: _ctx.$t('bulkBooking.insertName'),
                  modelValue: _ctx.filterClient.cityOriginCode,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterClient.cityOriginCode = $event)),
                    _ctx.onChangeCityDestination
                  ]
                }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"]),
                _hoisted_9,
                _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('bulkBooking.serviceType')), 1),
                _createVNode(_component_MultipleSelectSearch, {
                  onChange: _ctx.onChangeShipmentType,
                  status: "active",
                  class: "my-1.5",
                  options: _ctx.optionsProduct,
                  placeholder: _ctx.$t('bulkBooking.chooseType'),
                  modelValue: _ctx.filterClient.shipmentType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterClient.shipmentType = $event))
                }, null, 8, ["onChange", "options", "placeholder", "modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["model-value", "onOpened", "addSumFilter"]),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_SelectSearch, {
              isFirstInput: true,
              options: _ctx.clients,
              onFocus: _ctx.onSearchValue,
              onFilter: _ctx.onSearchValue,
              keyName: "name",
              keyValue: "id",
              placeholder: _ctx.$t('bulkBooking.insertAlias'),
              modelValue: _ctx.modelValue.clientName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.clientName = $event)),
              isLoading: _ctx.isLoadingClients,
              onChange: _ctx.onChageClientName,
              isShowErrorMessage: false,
              isShowErrorIndicator: _ctx.isErrorClient || _ctx.errorMandatory,
              errorCaption: 
                _ctx.errorMandatory
                  ? _ctx.$t('bulkBooking.clientNameMustInsert')
                  : _ctx.$t('bulkBooking.clinetNotBook')
              ,
              class: [_ctx.isErrorClient || _ctx.errorMandatory ? 'mt-8' : 'my-2 bg-gray-lp-1500', "w-full"],
              isDisabled: ""
            }, null, 8, ["options", "onFocus", "onFilter", "placeholder", "modelValue", "isLoading", "onChange", "isShowErrorIndicator", "errorCaption", "class"]),
            _createVNode(_component_button_outline, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onShowPopupFilterClient(true))),
              isDisabled: "",
              title: _ctx.$t('bulkBooking.clientList'),
              custom: "w-48 border-gray-lp-1500 text-gray-lp-300 bg-gray-lp-1500 cursor-not-allowed",
              style: {"height":"40px"},
              class: "mr-4",
              colorTextButton: "text-gray-lp-300"
            }, null, 8, ["title"])
          ])
        ], 2),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.summaryFilter, (item, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                _createVNode("div", _hoisted_14, [
                  _createTextVNode(_toDisplayString(item.value) + " ", 1),
                  _createVNode(_component_Icons, {
                    onClick: ($event: any) => (_ctx.onDeleteSummary(item.from)),
                    name: "icon-x",
                    class: "ml-2 w-4 text-gray-lp-600 cursor-pointer"
                  }, null, 8, ["onClick"])
                ])
              ]))
            }), 128)),
            (_ctx.summaryFilter.length)
              ? (_openBlock(), _createBlock("p", {
                  key: 0,
                  class: "text-14px font-semibold font-montserrat cursor-pointer mb-2",
                  style: {"color":"#B82025"},
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onResetFilter && _ctx.onResetFilter(...args)))
                }, " Reset "))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _hoisted_15
    ]),
    (_ctx.showPopupFilterClient)
      ? (_openBlock(), _createBlock(_component_ModalV2, {
          key: 0,
          width: "w-8/12",
          showBorderTitle: false,
          showFooter: false,
          scrollable: false,
          title: _ctx.$t('bulkBooking.clientList'),
          onClose: () => _ctx.onClosePopupFilter()
        }, {
          content: _withId(() => [
            (!_ctx.isErrorGetClient)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode(_component_AdvancedFilter, {
                    "custom-max-height": "60vh",
                    "model-value": _ctx.filterClient,
                    isDisabled: false,
                    onOpened: _ctx.onOpenedAdvancedFilter,
                    onReset: ($event: any) => (
              {
              }
            ),
                    addSumFilter: _ctx.sumFilter,
                    showIconFilter: true,
                    showCountFilter: false,
                    showChevron: false,
                    isSeparateContent: "",
                    customTitleFilter: "text-14px font-semibold text-gray-lp-300"
                  }, {
                    "custom-filter": _withId(() => [
                      _createVNode("div", _hoisted_17, [
                        _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('bulkBooking.filterClientName')), 1),
                        _hoisted_19
                      ]),
                      _createVNode("div", _hoisted_20, [
                        _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('bulkBooking.cityOriginClient')), 1),
                        _createVNode(_component_SelectSearchV2, {
                          onFilter: _ctx.fetchCityDestination,
                          onFocus: _ctx.fetchCityDestination,
                          isLoading: _ctx.loadingCityDestination,
                          options: _ctx.cityDestinationData,
                          keyName: "name",
                          keyValue: "name",
                          placeholder: _ctx.$t('bulkBooking.insertName'),
                          modelValue: _ctx.filterClient.cityOriginCode,
                          "onUpdate:modelValue": [
                            _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterClient.cityOriginCode = $event)),
                            _ctx.onChangeCityDestination
                          ]
                        }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"]),
                        _hoisted_22,
                        _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('bulkBooking.serviceType')), 1),
                        _createVNode(_component_MultipleSelectSearch, {
                          onChange: _ctx.onChangeShipmentType,
                          status: "active",
                          class: "my-1.5",
                          options: _ctx.optionsProduct,
                          placeholder: _ctx.$t('bulkBooking.chooseType'),
                          modelValue: _ctx.filterClient.shipmentType,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterClient.shipmentType = $event))
                        }, null, 8, ["onChange", "options", "placeholder", "modelValue"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["model-value", "onOpened", "addSumFilter"]),
                  _createVNode(_component_Search, {
                    class: "w-full",
                    onInput: search => _ctx.onSearchValue(search, true),
                    onClear: _ctx.clearSearch,
                    value: _ctx.searchValue,
                    placeholder: _ctx.$t('bulkBooking.searchbyName'),
                    colorIcon: "#4D4D4D"
                  }, null, 8, ["onInput", "onClear", "value", "placeholder"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_24, [
              _createVNode(_component_TableV2, {
                columns: _ctx.columns,
                onRequest: _cache[8] || (_cache[8] = 
              () =>
                _ctx.fetchdDataClients({ isDirectory: true, infiniteScroll: true })
            ),
                data: _ctx.clients,
                loading: _ctx.isLoadingClients,
                errorCause: _ctx.isErrorGetClient,
                isDetailAble: "",
                onClick: (item) => _ctx.goToDetail(item),
                paginationStyle: "v3",
                pagination: _ctx.pagination,
                "onUpdate:pagination": _cache[9] || (_cache[9] = ($event: any) => (_ctx.pagination = $event)),
                borderTop: false,
                borderBottom: false,
                isEmpty: _ctx.isEmpty,
                bgHeader: "bg-white",
                hidePagination: "",
                isNoPaddingBottom: "",
                infiniteScroll: ""
              }, null, 8, ["columns", "data", "loading", "errorCause", "onClick", "pagination", "isEmpty"])
            ])
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true)
  ]))
})